;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["csrf_token"],
    data: function data() {
        return {
            groups: [{ gateway_transaction_id: '', ref_no: '', identifier: 'NHIFM', response: {} }],
            showValidationError: false
        };
    },

    methods: {
        addGroup: function addGroup() {
            this.groups.push({ gateway_transaction_id: '', ref_no: '', identifier: 'NHIFM', response: {} });
        },
        removeGroup: function removeGroup(index) {
            this.groups.splice(index, 1);
        },
        allFieldsFilled: function allFieldsFilled() {
            return this.groups.every(function (group) {
                return group.gateway_transaction_id && group.ref_no && group.identifier;
            });
        },
        handleSubmit: function handleSubmit() {
            if (this.allFieldsFilled()) {
                this.showValidationError = false;
                this.submitGroups();
                console.log('Submitting:', this.groups);
            } else {
                this.showValidationError = true;
            }
        },
        submitGroups: async function submitGroups() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.groups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var group = _step.value;

                    try {
                        var response = await this.callManualReconApi(group);
                        console.log('Response for group:', response);
                        group.response = response;
                    } catch (error) {
                        console.error('Error submitting group:', error);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        callManualReconApi: async function callManualReconApi(group) {
            var payload = {
                gateway_transaction_id: group.gateway_transaction_id,
                ref_no: group.ref_no,
                identifier: group.identifier,

                _csrf_token: this.csrf_token
            };

            var response = await _axios2.default.post('/topup/to/invoice', payload);
            return response.data;
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[(_vm.showValidationError)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("\n    Please fill all fields in each group before submitting.\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.groups),function(group,index){return _c('div',{key:index,staticClass:"mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(group.gateway_transaction_id),expression:"group.gateway_transaction_id"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Gateway Ref"},domProps:{"value":(group.gateway_transaction_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(group, "gateway_transaction_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(group.ref_no),expression:"group.ref_no"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Ref No"},domProps:{"value":(group.ref_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(group, "ref_no", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(group.identifier),expression:"group.identifier"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(group, "identifier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"NHIFM"}},[_vm._v("NHIFM (Member Contribution)")]),_vm._v(" "),_c('option',{attrs:{"value":"NHIFP"}},[_vm._v("NHIFP (Member Penalty)")]),_vm._v(" "),_c('option',{attrs:{"value":"NHIFE"}},[_vm._v("NHIFE (Employer Contribution)")]),_vm._v(" "),_c('option',{attrs:{"value":"NHIFEP"}},[_vm._v("NHIFEP (Employer Penalty)")])])]),_vm._v(" "),_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){_vm.removeGroup(index)}}},[_vm._v("Remove")])])]),_vm._v(" "),(group.response.status == 1 && group.response.message)?_c('p',{staticClass:"alert alert-success m-2"},[_vm._v("\n        "+_vm._s(group.response.message)+"\n    ")]):_vm._e(),_vm._v(" "),(group.response.status == 0 && group.response.message)?_c('p',{staticClass:"alert alert-danger m-2"},[_vm._v("\n        "+_vm._s(group.response.message)+"\n    ")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-block",on:{"click":_vm.addGroup}},[_vm._v("Add Group")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.handleSubmit}},[_vm._v("Submit")])],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7878d7d5", __vue__options__)
  } else {
    hotAPI.reload("data-v-7878d7d5", __vue__options__)
  }
})()}